import { render, staticRenderFns } from "./DetailSummary.vue?vue&type=template&id=b0f3e162&scoped=true&"
import script from "./DetailSummary.vue?vue&type=script&lang=js&"
export * from "./DetailSummary.vue?vue&type=script&lang=js&"
import style0 from "./DetailSummary.vue?vue&type=style&index=0&id=b0f3e162&lang=scss&scoped=true&"
import style1 from "./DetailSummary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f3e162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f3e162')) {
      api.createRecord('b0f3e162', component.options)
    } else {
      api.reload('b0f3e162', component.options)
    }
    module.hot.accept("./DetailSummary.vue?vue&type=template&id=b0f3e162&scoped=true&", function () {
      api.rerender('b0f3e162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/DetailSummary.vue"
export default component.exports